// Errors
export const CHECK_ENABLED_ERROR = 'Something went wrong!';
export const GENERATE_QUOTE_ERROR = 'Could not generate quote!';
export const UPLOAD_FILE_ERROR = 'Upload file error!';
export const CREATE_POLICY_ERROR = 'Could not create policy!';
export const ITEM_UPDATE_ERROR = 'Something went wrong. Please try again.';
export const ASSURANT_ERROR = 'Assurant error!';
export const NOT_ENABLED_ERROR = 'Assurant not enabled!';

export const COVER360_PLUS_TILE_TITLE = 'Review your renters insurance options';

// Landing page
export const LANDING_PAGE_TITLE =
  'Purchase insurance or submit proof of coverage';

export const COVER360_PLUS_LANDING_PAGE_TITLE =
  'Here are your insurance options';
export const COVER360_PLUS_LANDING_PAGE_SUBTITLE =
  'Learn more about the Pay with Rent policy included with your lease. If you don’t want a Pay with Rent policy upload proof of coverage from another carrier below.';
export const LANDING_PAGE_SUBTITLE =
  'Buy insurance that’s conveniently bundled with your rent—quick and easy! You\u2019re automatically approved with no extra steps.';
export const LANDING_PAGE_POL_TITLE = 'Bundle insurance with your rent';
export const COVER360_PLUS_LANDING_PAGE_POL_TITLE =
  'Learn more about Pay with Rent';
export const COVER360_PLUS_LANDING_PAGE_POL_DESCRIPTION =
  'Review the policy you enrolled in at lease signing that meets your liability insurance requirement and includes personal contents coverage.';
export const LANDING_PAGE_POL_DESCRIPTION =
  'Buy insurance tailored to your move-in requirements. You won\u2019t need to submit proof of coverage.';
export const LANDING_PAGE_UPLOAD_TITLE = 'Upload proof of coverage';
export const LANDING_PAGE_UPLOAD_DESCRIPTION =
  'If you\u2019ve already purchased insurance, upload the declaration page of your policy here.';

// Upload proof page
export const UPLOAD_PAGE_TITLE = 'Upload your proof of coverage';
export const UPLOAD_PAGE_SUBTITLE =
  'Upload the declaration page from your policy documents so your coverage can be verified. Make sure it meets all of the insurance requirements listed on this screen.';
export const UPLOAD_PAGE_ALLOWED_TYPES_MESSAGE = 'PDFs, JPGs, and PNGs';
export const UPLOAD_PAGE_BUTTON = 'Finish';

// Upload proof receipt page
export const UPLOAD_RECEIPT_PAGE_TITLE = 'Thank you!';
export const UPLOAD_RECEIPT_PAGE_SUBTITLE =
  'Our insurance tracking provider, Assurant, will review and contact you if anything else is needed';
export const UPLOAD_RECEIPT_PROOF_TITLE = 'Proof of insurance';
export const UPLOAD_RECEIPT_BUTTON = 'Return home';

// POL page
export const POL_PAGE_TITLE = 'Review your coverage';
export const POL_PAGE_CALLOUT_TITLE =
  'Your policy provides coverage for damage to your personal property due to the following:';
export const POL_PAGE_CALLOUT_ITEM_1 = 'Vandalism & theft';
export const POL_PAGE_CALLOUT_ITEM_2 = 'Lightning, windstorm, hail';
export const POL_PAGE_CALLOUT_ITEM_3 = 'Fire, smoke & other risks';
export const POL_PAGE_CALLOUT_LINK = 'See full policy';
export const POL_PAGE_HIGHLIGHTS_TITLE = 'Policy highlights';
export const POL_PAGE_HIGHLIGHTS_ITEM_1 =
  'Meets your lease liability requirement';
export const POL_PAGE_HIGHLIGHTS_ITEM_3 = '{0} personal liability coverage';
export const POL_PAGE_HIGHLIGHTS_ITEM_4 = '{0} personal contents coverage';
export const POL_PAGE_HIGHLIGHTS_ITEM_5 = '$250 deductible';
export const POL_PAGE_PER_MONTH = '/mo';
export const POL_PAGE_BILLED_OVER_RENT = 'billed with your rent payment';
export const POL_PAGE_BUTTON = 'Purchase policy';
export const POL_PAGE_DISCLAIMER =
  'Please refer to your policy for full coverage details. Exclusions and limitations may apply.';

// POL confirmation
export const POL_CONFIRMATION_PAGE_TITLE = 'Please confirm your information';
export const POL_CONFIRMATION_PAGE_ROW_NAME = 'Name';
export const POL_CONFIRMATION_PAGE_ROW_EMAIL = 'Email';
export const POL_CONFIRMATION_PAGE_ROW_ADDRESS = 'Address';
export const POL_CONFIRMATION_PAGE_ROW_CITY = 'City';
export const POL_CONFIRMATION_PAGE_ROW_STATE = 'State';
export const POL_CONFIRMATION_PAGE_ROW_ZIP = 'Zip';
export const POL_CONFIRMATION_PAGE_ROW_POLICY_START = 'Policy start date';
export const POL_CONFIRMATION_PAGE_ROW_PREMIUM = 'Monthly premium';
export const POL_CONFIRMATION_PAGE_BILLED_WITH_RENT =
  'will be added to your monthly rent';
export const POL_CONFIRMATION_PAGE_BUTTON = 'Submit order';

export const POL_TEXAS_LIABILITY_COPY =
  'In Texas, Limited Personal Liability is provided through an insurance policy issued to your community by an excess and surplus lines carrier (the advertising of this program is not intended for Florida residents). These companies operate under the trade name Assurant.';

// POL receipt
export const POL_RECEIPT_PAGE_TITLE = 'You are all set!';
export const POL_RECEIPT_PAGE_SUBTITLE =
  'Thank you for purchasing Assurant’s pay-with-rent insurance! You’ve met your lease liability requirement, and your policy reservation number is listed below. Assurant will issue your policy once they confirm your lease status. \n \n In addition, Assurant will let your community know that you’ve met your requirement, so you don’t need to take any other steps. \n \n Once your policy is issued, Assurant will send you a confirmation email with your official policy number and mail your policy documents within seven to 10 business days. Your policy will be active on your lease effective date at move-in and the $14.50 monthly premium will be added to your rent payment. \n \n A summary of your reservation is listed below:';
export const POL_RECEIPT_PAGE_POLICY_NUMBER = 'Policy Reservation Number';
export const POL_RECEIPT_PAGE_BILLED_WITH_RENT =
  '/mo will be added to your monthly rent';
export const POL_RECEIPT_PAGE_BUTTON = 'Return home';
export const COVER360_PRODUCT_NAME = 'Cover360';
export const COVER360_PLUS_PRODUCT_NAME = 'Cover360Plus';
export const COVER360_PLUS_STD_COVERAGE_BUTTON = 'I understand';

// cover360_plus standard coverage disclosures
export const COVER360_PLUS_STD_COVERAGE_DISCLOSURES_SUFFIX =
  'related to your Pay with Rent policy. No further action is required. A policy package should arrive within 7-10 business days after your lease effective date.';

// Opt-out page (cover360_plus, once past the move-in upload deadline)
export const OPT_OUT_PAGE_TITLE = 'Have Your Own Renters Insurance?';
export const OPT_OUT_PAGE_SUBTITLE_PREFIX =
  "You enrolled in a Pay with Rent policy at lease signing. Don't want to keep the policy? Email proof of coverage to";
export const OPT_OUT_PAGE_ASSURANT_EMAIL = 'insurancetracking@assurant.com';
export const OPT_OUT_PAGE_CALLOUT_TITLE =
  'Cover360Plus includes coverage for damage to your personal property, including for:';
export const OPT_OUT_PAGE_CALLOUT_FOOTNOTE =
  'See policy for details, including terms, limitations and exclusions.';
export const OPT_OUT_PAGE_REQUIREMENTS_TITLE =
  'Prefer to bring your own policy?';
export const OPT_OUT_PAGE_REQUIREMENTS_SUBTITLE =
  'Proof of coverage must show:';
export const OPT_OUT_PAGE_REQUIREMENT_ADDRESS =
  'Address listed on your lease or Insured address';
export const OPT_OUT_PAGE_REQUIREMENT_NAME = 'Your full name';
export const OPT_OUT_PAGE_REQUIREMENT_LIABILITY =
  '$100,000 personal liability coverage';

export const REQUIREMENTS_ITEM_1 =
  'Your renters insurance must cover a minimum of {0} in liability coverage. ';
export const REQUIREMENTS_ITEM_2 =
  'Your property and {0} must be named on the policy as additional insured and/or interested party. ';
export const REQUIREMENTS_ITEM_3 =
  'Please remember to bring a copy of your policy on move-in day, effective that date. ';
